
<template>
  <div>
    <h2 id="product_parent" class="sp-titl_h2_1"><i class="icon-bulldozer"></i>{{myTopCategory.name}}</h2>
    <div v-for="child in myTopCategory.child" v-bind:key="child.id">
      <h3 class="sp-titl_h3_1" data-toggle="collapse" href="#category1" role="button" aria-expanded="true" aria-controls="category1">{{child.name}}</h3>
      <div v-if="child.child.length > 0" id="category1">
        <div class="speclist">
          <a tabindex="-1" style="pointer-events: none;"><img :src="categoryImage[child.id] || noImagePath" :alt="child.name" @error="onImageError"></a>
          <ul>
          <li v-for="children in child.child" v-bind:key="children.id">
            <router-link :to="{name: 'list', params: {Id: children.id}}" class="btn btn-outline-warning btn-block text-left btn-child">{{children.name}}</router-link>
          </li>
          </ul>
        </div>
      </div>
      <div v-else id="category1">
        <div class="speclist">
          <a tabindex="-1"><img :src="categoryImage[child.id] || noImagePath" :alt="child.name" @error="onImageError"></a>
          <ul>
          <li>
            <router-link :to="{name: 'list', params: {Id: child.id}}" class="btn btn-outline-warning btn-block text-left btn-child">{{child.name}}</router-link>
         </li>
         </ul>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    inject: ['setBreadcrumbContext', 'setPageMeta'],
    data: function () {
      return {
        categoryImages: [],
        sortCategories: [],
        myTopCategory: [
          {
            'id': null,
            'name': null,
            'image': '',
            'child': [
              {
                'id': null,
                'name': null,
                'child': []
              }
            ]
          }
        ],
        categoryImage: {},
        noImagePath: process.env.BASE_URL + 'img/noimage.png'
      }
    },
    props: {
      categorySet: {
        type: Array,
        require: true
      }
    },
    mounted () {
      if(this.categorySet.length>0){
        this.sortCategories = this.categorySet
        this.setMyTopCategory()
        for(var i=0; i<this.myTopCategory.child.length; i++){
          if(this.myTopCategory.child[i].child.length > 0){
            this.getImagePath(this.myTopCategory.child[i].id, this.myTopCategory.child[i].child[0].id)
          }else{
            this.getImagePath(this.myTopCategory.child[i].id, this.myTopCategory.child[i].id)
          }
        }
        this.syncPageContext()
      }
    },
    methods: {
      onImageError: function (event) {
        if (event && event.target && event.target.src && event.target.src.indexOf(this.noImagePath) === -1) {
          event.target.src = this.noImagePath
        }
      },
      kenkiImagePath: function (product_code,n) {
        return '/kenki_images/1/' + product_code + '-' + ('00' + (n+1)).slice(-2) + '.jpg'
      },
      setMyTopCategory: function (){
        var target = this.myTopCategory
        var targetItems = []
        var specName = this.$route.params.Spec
        targetItems = this.sortCategories.filter(function(item){
          if((item.name).indexOf(specName)>=0) return true
        })
        target = targetItems[0]
        this.myTopCategory = target       
      },
      syncPageContext: function () {
        var title = this.myTopCategory && this.myTopCategory.name ? this.myTopCategory.name : this.$route.params.Spec
        this.setBreadcrumbContext(this.myTopCategory ? this.myTopCategory.id : null, title)
        this.setPageMeta(title)
      },
      getImagePath: function (category_id, id) {
        var myId = id
        var url = process.env.VUE_APP_URL + '/stock_products/search'
        var myToken = process.env.VUE_APP_TOKEN
        var myComId = process.env.VUE_APP_COMPANY_ID
        var param = {}
        param = {
          'limit': 100,
          'stock_product': {
              'category_id': myId,
              'company_id': myComId
          }
        }
        fetch(url, {
          method: "POST",
          mode: "cors",
          headers:  {
            'Content-Type': 'application/json',
             'Authorization': `Token ${myToken}`
          },
          body: JSON.stringify(param)
        })
        .then(res => {
          return res.json()
        })
        .then(data => {
          if (data && data[0] && data[0].product) {
            this.categoryImage[category_id] = this.kenkiImagePath(data[0].product.product_code, 0)
          } else {
            this.categoryImage[category_id] = this.noImagePath
          }
        })
        .catch(e => console.error(e))
      },
    },
    watch: {
      categorySet(newSet){
        this.sortCategories = newSet
        this.setMyTopCategory()
        for(var i=0; i<this.myTopCategory.child.length; i++){
          if(this.myTopCategory.child[i].child.length > 0){
            this.getImagePath(this.myTopCategory.child[i].id, this.myTopCategory.child[i].child[0].id)
          }else{
            this.getImagePath(this.myTopCategory.child[i].id, this.myTopCategory.child[i].id)
          }
        }
        this.syncPageContext()
      }
    }
    
  }
</script>
